<template>
  <section class="cta-banner py-16">
    <!-- Decorative background elements -->
    <div class="cta-glow"></div>
    <div class="cta-grid"></div>

    <v-container class="position-relative z-index-2">
      <div class="cta-content text-center mx-auto" style="max-width: 820px;">
        <v-chip
          color="white"
          variant="outlined"
          size="small"
          class="font-weight-bold mb-4 px-4 text-uppercase"
        >
          ASESORÍA INMOBILIARIA PERSONALIZADA
        </v-chip>

        <h2 class="cta-title mb-6 text-white font-weight-black">
          ¿Desea Vender, Comprar o Arrendar su Inmueble en el norte de Cundinamarca?
        </h2>

        <p class="cta-subtitle mb-10 text-grey-lighten-2 mx-auto">
          Confíe su patrimonio a la firma inmobiliaria consolidada de la región. Más de 17 años brindando seguridad jurídica en títulos, agilidad en trámites y máxima visibilidad comercial.
        </p>

        <!-- CTA Buttons -->
        <div class="d-flex flex-wrap justify-center gap-4 mb-8">
          <v-btn
            color="white"
            size="x-large"
            elevation="8"
            href="https://wa.me/573112160295"
            target="_blank"
            class="cta-btn-primary font-weight-bold px-8 py-3"
          >
            <v-icon left color="primary" class="mr-2">mdi-whatsapp</v-icon>
            <span class="text-primary">Contactar por WhatsApp</span>
          </v-btn>

          <v-btn
            variant="outlined"
            size="x-large"
            color="white"
            href="tel:+573112160295"
            class="cta-btn-secondary font-weight-bold px-8 py-3"
          >
            <v-icon left class="mr-2">mdi-phone</v-icon>
            Llamar a un Asesor
          </v-btn>
        </div>

        <!-- Trust footer notes -->
        <div class="d-flex flex-wrap justify-center align-center text-caption text-grey-lighten-1 gap-6">
          <div class="d-flex align-center">
            <v-icon size="16" color="white" class="mr-2">mdi-shield-check</v-icon>
            Estudio Técnico de Títulos
          </div>
          <div class="d-flex align-center">
            <v-icon size="16" color="white" class="mr-2">mdi-map-marker-radius</v-icon>
            7 Municipios del Norte de Cundinamarca
          </div>
          <div class="d-flex align-center">
            <v-icon size="16" color="white" class="mr-2">mdi-clock-check-outline</v-icon>
            Respuesta y Gestión Ágil
          </div>
        </div>

        <!-- PREMIUM CONTACT INFO BOX -->
        <div class="cta-contact-box mt-10 pa-6 mx-auto">
          <v-row class="align-center justify-center text-left" dense>
            <v-col cols="12" md="6" class="d-flex align-center mb-3 mb-md-0">
              <v-avatar color="primary" size="44" class="mr-4 shadow-sm flex-shrink-0">
                <v-icon color="white" size="22">mdi-map-marker</v-icon>
              </v-avatar>
              <div>
                <div class="text-caption text-grey-lighten-2 font-weight-bold text-uppercase">
                  Sede Principal
                </div>
                <div class="text-body-2 font-weight-black text-white">
                  Carrera 3 # 3 - 11 centro, Piso 2
                </div>
                <div class="text-caption text-grey-lighten-1">
                  Gachancipá, Cundinamarca
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6" class="d-flex align-center">
              <v-avatar color="primary" size="44" class="mr-4 shadow-sm flex-shrink-0">
                <v-icon color="white" size="22">mdi-phone</v-icon>
              </v-avatar>
              <div>
                <div class="text-caption text-grey-lighten-2 font-weight-bold text-uppercase">
                  Línea de Atención & WhatsApp
                </div>
                <div class="text-body-2 font-weight-black text-white">
                  +57 311 216 0295
                </div>
                <div class="text-caption text-grey-lighten-1">
                  Lunes a Sábado • 8:00 am - 6:00 pm
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'CtaBanner',
};
</script>

<style scoped>
.cta-contact-box {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  backdrop-filter: blur(16px);
  max-width: 720px;
}

.cta-banner {
  position: relative;
  background: radial-gradient(circle at 50% 50%, #A90707 0%, #7d0505 60%, #580303 100%);
  overflow: hidden;
  color: #ffffff;
}

.cta-glow {
  position: absolute;
  top: -30%;
  left: 20%;
  width: 500px;
  height: 500px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  filter: blur(90px);
  pointer-events: none;
}

.cta-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.12) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
}

.cta-title {
  font-size: clamp(1.9rem, 4vw, 3rem);
  line-height: 1.2;
}

.cta-subtitle {
  font-size: clamp(1.05rem, 2vw, 1.25rem);
  line-height: 1.6;
  max-width: 660px;
}

.gap-4 {
  gap: 16px;
}

.gap-6 {
  gap: 24px;
}

.cta-btn-primary {
  background-color: #ffffff !important;
  border-radius: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cta-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35) !important;
}

.cta-btn-secondary {
  border-color: rgba(255, 255, 255, 0.45) !important;
  border-radius: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cta-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: #ffffff !important;
  transform: translateY(-3px);
}
</style>
